module.exports = __webpack_public_path__ + "static/media/WELAWA.218fccb9.png";